/* eslint-disable */
// @ts-nocheck
'use client'
import Script from 'next/script'
import { useEffect } from 'react'

export const ExternalScripts = () => {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_QUALTRICS_ZID && process.env.NEXT_PUBLIC_QUALTRICS_URL) {
      ;(function () {
        const g = function (e, h, f, g) {
          this.get = function (a) {
            for (var a = a + '=', c = document.cookie.split(';'), b = 0, e = c.length; b < e; b++) {
              for (var d = c[b]; ' ' == d.charAt(0); ) d = d.substring(1, d.length)
              if (0 == d.indexOf(a)) return d.substring(a.length, d.length)
            }
            return null
          }
          this.set = function (a, c) {
            var b = '',
              b = new Date()
            b.setTime(b.getTime() + 6048e5)
            b = '; expires=' + b.toGMTString()
            document.cookie = a + '=' + c + b + '; path=/; '
          }
          this.check = function () {
            let a = this.get(f)
            if (a) a = a.split(':')
            else if (100 != e)
              'v' == h && (e = Math.random() >= e / 100 ? 0 : 100), (a = [h, e, 0]), this.set(f, a.join(':'))
            else return !0
            let c = a[1]
            if (100 == c) return !0
            switch (a[0]) {
              case 'v':
                return !1
              case 'r':
                return (c = a[2] % Math.floor(100 / c)), a[2]++, this.set(f, a.join(':')), !c
            }
            return !0
          }
          this.go = function () {
            if (this.check()) {
              const a = document.createElement('script')
              a.type = 'text/javascript'
              a.src = g
              document.body && document.body.appendChild(a)
            }
          }
          this.start = function () {
            const t = this
            'complete' !== document.readyState
              ? window.addEventListener
                ? window.addEventListener(
                    'load',
                    function () {
                      t.go()
                    },
                    !1
                  )
                : window.attachEvent &&
                  window.attachEvent('onload', function () {
                    t.go()
                  })
              : t.go()
          }
        }
        try {
          new g(
            100,
            'r',
            `QSI_S_${process.env.NEXT_PUBLIC_QUALTRICS_ZID}`,
            process.env.NEXT_PUBLIC_QUALTRICS_URL
          ).start()
        } catch (i) {}
      })()
    }

    if (process.env.NEXT_PUBLIC_GTAG_ENABLED === 'true' && process.env.NEXT_PUBLIC_GTM_ID) {
      ;(function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', `${process.env.NEXT_PUBLIC_GTM_ID}`)
    }

    if (process.env.NEXT_PUBLIC_GTAG_ENABLED === 'true' && process.env.NEXT_PUBLIC_GTAG_APP_ID) {
      window.dataLayer = window.dataLayer || []
      function gtag() {
        dataLayer.push(arguments)
      }
      gtag('js', new Date())

      gtag('config', `${process.env.NEXT_PUBLIC_GTAG_APP_ID}`)
    }
  }, [])

  return (
    <>
      {process.env.NEXT_PUBLIC_ENV === 'prod' && (
        <Script type='text/javascript' id='dt-loader' async src='/scripts/dt-loader/prod-dt-loader-2.1.1.dist.js' />
      )}
      {process.env.NEXT_PUBLIC_ENV !== 'prod' && process.env.NEXT_PUBLIC_ENV !== 'dev' && (
        <Script type='text/javascript' id='dt-loader' async src='/scripts/dt-loader/dt-loader-2.1.1.dist.js' />
      )}
      <Script type='text/javascript' id='dt-naf' async src='/scripts/dt-naf/dt-naf-collector-1.6.2.dist.js' />
      {process.env.NEXT_PUBLIC_GTAG_ENABLED === 'true' && process.env.NEXT_PUBLIC_GTAG_APP_ID && (
        <Script
          id='gtag'
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GTAG_APP_ID}`}
        />
      )}
      {process.env.NEXT_PUBLIC_HUBSPOT_ENABLED === 'true' && (
        <Script type='text/javascript' id='hs-script-loader' async defer src='https://js.hs-scripts.com/4764334.js' />
      )}
      {/* <!-- Google Tag Manager (noscript) --> */}
      {process.env.NEXT_PUBLIC_GTAG_ENABLED === 'true' && process.env.NEXT_PUBLIC_GTM_ID && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_ID}`}
            height='0'
            width='0'
            style={{ display: 'none', visibility: 'hidden' }}
          ></iframe>
        </noscript>
      )}
      {/* <!--BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET--> */}
      <div id={process.env.NEXT_PUBLIC_QUALTRICS_ZID}>{/* <!--DO NOT REMOVE-CONTENTS PLACED HERE--> */}</div>
      {/* <!--END WEBSITE FEEDBACK SNIPPET--> */}
      {process.env.NEXT_PUBLIC_SITEIMPROVE_ENABLED === 'true' && (
        <Script
          id='Siteimprove Analytics'
          type='text/javascript'
          async
          src='//siteimproveanalytics.com/js/siteanalyze_77682.js'
        />
      )}
    </>
  )
}
